<template>
  <van-tabs v-model="active">
    <van-tab title="我的客户">
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="goods-list">
            <div
              v-for="(item, index) in AllList"
              :key="index"
              class="goods-item d-flex flex-row justify-content-between align-items-center"
            >
              <div style="display: flex">
                <van-image width="40" height="40" :src="item.avatar" round />
                <div style="margin-left: 20px">
                  <div>{{ item.nickname }}</div>
                  <div>{{ item.phone }}</div>
                </div>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </van-tab>
    <van-tab title="客户订单">
    <my-refresh-more
          class="list-scroll-content"
          :pageSize="10"
           v-model="list"
          :getList="getList"
        >
          <!-- 订单列表 -->
          <div
            slot="list"
            v-for="(item, index) in list"
            :key="index"
            class="order-item"
          >
            <div class="i-top b-b">
              <div class="flex-1">
                <span class="time">{{ item.createTime }}</span>
              </div>
              <span class="state" :style="{ color: item.stateTipColor }">{{
                item.stateTip
              }}</span>
             <img :src="item.avatar" alt="" style="width:40px;height:40px;border-radius: 100%;margin-top:10px">
            </div>

            <div v-if="item.orderItems.length > 1" class="goods-box">
              <div
                v-for="(goodsItem, goodsIndex) in item.orderItems"
                :key="goodsIndex"
                class="goods-item"
              >
                <van-image
                  lazy-load
                  class="goods-img"
                  width="80"
                  height="80"
                  :src="goodsItem.productPic"
                  mode="aspectFill"
                ></van-image>
              </div>
            </div>
            <div
              v-if="item.orderItems.length === 1"
              class="goods-box-single"
              v-for="(goodsItem, goodsIndex) in item.orderItems"
              :key="goodsIndex"
            >
              <van-image
                lazy-load
                class="goods-img"
                width="80"
                height="80"
                :src="goodsItem.productPic"
                mode="aspectFill"
              ></van-image>
              <div class="right">
                <span class="title clamp">{{ goodsItem.productName }}</span>
                <span class="attr-box"
                  >{{ goodsItem.productSpec }} x {{ goodsItem.quantity }}</span
                >
                <span class="price">{{ goodsItem.price }}</span>
              </div>
            </div>

            <div class="price-box">
              共
              <span class="num">{{ item.orderItems.length }}</span>
              件商品 实付款
              <span class="price">{{ item.needPayPrice }}</span>
            </div>
          </div>
        </my-refresh-more>
    </van-tab>
  </van-tabs>
</template>

<script>
export default {
  data() {
    return {
      AllList: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 1,
      active:0,
      list: [],
    };
  },

  created() {},
  methods: {
     getList (page, size, param) {
      let params = {
        page: page,
        size: size,
      }
      console.log('getList', params)
      return new Promise((resolve, reject) => {
        this.$http.request(this.$http.pathMap.customerList, 'get', params).then(res => {
          let data = res.data
         
          resolve(data)
        })
      })
    },
    async onLoad() {
      try {
        if (this.refreshing) {
          this.AllList = [];
          this.page = 1;
          this.refreshing = false;
        }
        let params = {
          page: this.page,
          size: 10,
        };
        const { data } = await this.$http.request(
          this.$http.pathMap.subordinateUser,
          "get",
          params
        );
        this.AllList = [...this.AllList, ...data.list];
        this.loading = false;
        this.refreshing = false;
        if (data.hasNextPage) {
          this.page++;
        } else {
          this.finished = true;
        }
      } catch (error) {
        return error;
      }
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
};
</script>

<style lang="scss" scoped>
/* 分类 */
/* 商品列表 */
.goods-list {
  padding: 0 15px;
  background: #fff;
  .goods-item {
    
    display: flex;
    flex-direction: row;
    width: 100%;
    padding: 10px;
    border-bottom: 1px rgba(230, 230, 230, 1) solid;
    margin-bottom: 10px;
    .timeStr {
      color: $font-color-light;
      font-size: $uni-font-size-lg;
    }
  }
}
page,
.content {
  background: $page-color-base;
  height: 100%;
}

.van-swiper-box {
  height: calc(100% - 40px);
}

.list-scroll-content {
  height: 100%;
  overflow-y: scroll;
}

.navTabBar {
  display: flex;
  justify-content: space-between;
  height: 40px;
  padding: 0 5px;
  background: #fff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.06);
  position: relative;
  z-index: 10;

  .nav-item {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    font-size: 15px;
    color: $font-color-dark;
    position: relative;

    &.current {
      color: $base-color;

      &:after {
        content: "";
        position: absolute;
        left: 50%;
        bottom: 0;
        transform: translateX(-50%);
        width: 44px;
        height: 0;
        border-bottom: 2px solid $base-color;
      }
    }
  }
}

.uni-van-swipe-item {
  height: auto;
}

.order-item {
  display: flex;
  flex-direction: column;
  padding-left: 15px;
  background: #fff;
  margin-top: 8px;

  .i-top {
    display: flex;
    align-items: center;
    height: 40px;
    padding-right: 15px;
    font-size: $uni-font-size-base;
    color: $font-color-dark;
    position: relative;

    .time {
      margin-left: 5px;
      flex: 1;
    }

    .state {
      color: $base-color;
    }

    .del-btn {
      padding: 5px 0 5px 18px;
      font-size: $uni-font-size-lg;
      color: $font-color-light;
      position: relative;

      &:after {
        content: "";
        width: 0;
        height: 15px;
        border-left: 1px solid $uni-border-color-dark;
        position: absolute;
        left: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }

  /* 多条商品 */
  .goods-box {
    height: 100px;
    padding: 10px 0;
    white-space: nowrap;
    overflow-x: scroll;

    .goods-item {
      width: 80px;
      height: 80px;
      display: inline-block;
      margin-right: 12px;
    }

    .goods-img {
      display: block;
      width: 100%;
      height: 100%;
    }
  }

  /* 单条商品 */
  .goods-box-single {
    display: flex;
    padding: 10px 0;

    .goods-img {
      display: block;
      width: 80px;
      height: 80px;
    }

    .right {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 0 15px 0 12px;
      overflow: hidden;

      .title {
        font-size: $uni-font-size-base + 1px;
        color: $font-color-dark;
        line-height: 1;
      }

      .attr-box {
        font-size: $uni-font-size-sm + 1px;
        color: $font-color-light;
        padding: 5px 6px;
      }

      .price {
        font-size: $uni-font-size-base + 1px;
        color: $font-color-dark;

        &:before {
          content: "￥";
          font-size: $uni-font-size-sm;
          margin: 0 1px 0 4px;
        }
      }
    }
  }

  .price-box {
    display: flex;
    justify-content: flex-end;
    align-items: baseline;
    padding: 10px 15px;
    font-size: $uni-font-size-sm + 1px;
    color: $font-color-light;

    .num {
      margin: 0 4px;
      color: $font-color-dark;
    }

    .price {
      font-size: $uni-font-size-lg;
      color: $font-color-dark;

      &:before {
        content: "￥";
        font-size: $uni-font-size-sm;
        margin: 0 1px 0 4px;
      }
    }
  }

  .action-box {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 50px;
    position: relative;
    padding-right: 15px;
  }

  .action-btn {
    height: 30px;
    margin: 0;
    margin-left: 12px;
    padding: 0 10px;
    text-align: center;
    line-height: 30px;
    font-size: $uni-font-size-sm + 1px;
    // color: white;
    background: #fff;
    border-radius: 100px;
    border: 1px #f8f8f8 solid;

    &:after {
      border-radius: 100px;
    }

    &.recom {
      background: #fff9f9;
      color: $base-color;

      &:after {
        border-color: #f7bcc8;
      }
    }
  }
}

/* load-more */
.uni-load-more {
  display: flex;
  flex-direction: row;
  height: 40px;
  align-items: center;
  justify-content: center;
}

.uni-load-more__text {
  font-size: 14px;
  color: #999;
}

.uni-load-more__img {
  height: 24px;
  width: 24px;
  margin-right: 10px;
}

.uni-load-more__img > div {
  position: absolute;
}

.uni-load-more__img > div div {
  width: 6px;
  height: 2px;
  border-top-left-radius: 1px;
  border-bottom-left-radius: 1px;
  background: #999;
  position: absolute;
  opacity: 0.2;
  transform-origin: 50%;
  animation: load 1.56s ease infinite;
}

.uni-load-more__img > div div:nth-child(1) {
  transform: rotate(90deg);
  top: 2px;
  left: 9px;
}

.uni-load-more__img > div div:nth-child(2) {
  transform: rotate(180deg);
  top: 11px;
  right: 0;
}

.uni-load-more__img > div div:nth-child(3) {
  transform: rotate(270deg);
  bottom: 2px;
  left: 9px;
}

.uni-load-more__img > div div:nth-child(4) {
  top: 11px;
  left: 0;
}

.load1,
.load2,
.load3 {
  height: 24px;
  width: 24px;
}

.load2 {
  transform: rotate(30deg);
}

.load3 {
  transform: rotate(60deg);
}

.load1 div:nth-child(1) {
  animation-delay: 0s;
}

.load2 div:nth-child(1) {
  animation-delay: 0.13s;
}

.load3 div:nth-child(1) {
  animation-delay: 0.26s;
}

.load1 div:nth-child(2) {
  animation-delay: 0.39s;
}

.load2 div:nth-child(2) {
  animation-delay: 0.52s;
}

.load3 div:nth-child(2) {
  animation-delay: 0.65s;
}

.load1 div:nth-child(3) {
  animation-delay: 0.78s;
}

.load2 div:nth-child(3) {
  animation-delay: 0.91s;
}

.load3 div:nth-child(3) {
  animation-delay: 1.04s;
}

.load1 div:nth-child(4) {
  animation-delay: 1.17s;
}

.load2 div:nth-child(4) {
  animation-delay: 1.3s;
}

.load3 div:nth-child(4) {
  animation-delay: 1.43s;
}

@-webkit-keyframes load {
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0.2;
  }
}
.van-tag {
  transform: scale(0.8);
  margin-left: -5px;
}
</style>
